import React from 'react';
import { Typography } from 'antd';
import { CloudFilled } from '@ant-design/icons';
import { CloudIcons } from '../../constants';
const { Text } = Typography;

const CciCloud = ({ cci, showLabel = false }) => {
    const getCclObject = () => {
        const cciValue = parseInt(cci);
        if (cciValue >= CloudIcons.excellent.minValue) {
            return CloudIcons.excellent;
        }
        if (cciValue >= CloudIcons.high.minValue) {
            return CloudIcons.high;
        }
        if (cciValue >= CloudIcons.medium.minValue) {
            return CloudIcons.medium;
        }
        if (cciValue >= CloudIcons.low.minValue) {
            return CloudIcons.low;
        }
        if (cciValue >= CloudIcons.poor.minValue) {
            return CloudIcons.poor;
        }
        return CloudIcons.unknown;
    };

    const ccl = getCclObject();

    return (
        <div className='ns-flex ns-items-center ns-flex_gap'>
            <div className='ns-relative' style={{ width: '2rem' }}>
                <CloudFilled style={{ fontSize: '2rem', color: ccl.color }} />
                <span className='ns-absolute ns-flex ns-flex_centered ns-inset-none ns-text-white'>{cci}</span>
            </div>
            {showLabel && <Text>{ccl.label}</Text>}
        </div>
    );
};

export default CciCloud;
